import { Form } from "antd"
import { Card, Divider, Group, Icon, InputNumber, Number } from "components/common"
import { InfoBlock } from "components/custom"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { getCurrencySymbol } from "utils"

const MortgageCalculationSummary = ({ mortgageAssessmentData, currency, rules, debouncedSubmit, form }) => {
  const { t } = useTranslation()

  useEffect(() => {
    form.setFieldsValue({
      eligibleMonthlyInstallment: mortgageAssessmentData?.eligibleMonthlyInstallment,
      tenor: mortgageAssessmentData?.tenor || 25,
    })
  }, [mortgageAssessmentData])

  return (
    <>
      <Card
        style={{
          boxShadow: "none",
          backgroundColor: mortgageAssessmentData?.mortgageSummaryColors?.eligibilityColor,
        }}
        bordered={false}
      >
        <InfoBlock
          data={mortgageAssessmentData?.eligibleInfoBlock}
          customComponentObj={{
            numberComponent: data => <Number value={data} defaultValue={0} isStringOnly tooltip showWholeNumber />,
            percentageComponent: data => (
              <Number value={data} defaultValue={0} isStringOnly wrapValue={v => `${v} %`} />
            ),
            iconComponent: icon => <Icon icon={icon} size="14px" />,
          }}
        />
      </Card>
      <Group gap="8px" style={{ margin: "12px 0px" }} template={"1fr 1fr"}>
        <Form.Item label={t("Monthly Installments")} name="eligibleMonthlyInstallment" rules={rules}>
          <InputNumber addonAfter={getCurrencySymbol()} readOnly precision={2} disabled />
        </Form.Item>
        <Form.Item
          label={t("Tenor")}
          name="tenor"
          rules={[
            {
              validator: async (_, value) => {
                if (value < 3) return Promise.reject(t("Tenor must be at least 3 years"))
                if (value > 25) return Promise.reject(t("Tenor cannot exceed 25 years"))
                return Promise.resolve()
              },
            },
          ]}
        >
          <InputNumber
            addonAfter={t("Years")}
            defaultValue={25}
            onChange={value => {
              form.setFieldValue("tenor", value)
              debouncedSubmit()
            }}
          />
        </Form.Item>
      </Group>
      <Divider style={{ marginBlock: 12 }} dashed />

      <InfoBlock
        title={t("Loan Breakdown")}
        data={mortgageAssessmentData?.loanInfoBlock}
        customComponentObj={{
          numberComponent: data => (
            <Number value={data} compact={false} defaultValue={0} isStringOnly tooltip showWholeNumber />
          ),
          percentageComponent: data => <Number value={data} defaultValue={0} wrapValue={v => `${v} %`} />,
        }}
      />
    </>
  )
}

export default MortgageCalculationSummary
